import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getTokenLogout } from "../actions/getTokenActions";
import { userLogout } from "../actions/userActions";
import { roleLogout } from "../actions/getRolesActions";
import { Link } from 'react-router-dom';
import intl from 'react-intl-universal';
import Cookies from 'universal-cookie';
import Logout from '@mui/icons-material/Logout';




  class AccountMenu extends Component { 
    
 logout = () => {
    const cookies = new Cookies();
    cookies.remove('token')
    cookies.remove('path')
    let isloginstring = {islogin: false};
    this.props.getTokenLogout(isloginstring);
    this.props.userLogout();
    this.props.roleLogout();
 } 

  render () {  
  

  const { userrights } = this.props
 

  let userrole = "";
  let userrolearray = this.props.userrole
  if (this.props.userrole !== undefined) {
    userrole = userrolearray[0]
}


if (this.props.userrole === undefined) {
  return (
    <Fragment>Loading</Fragment>
  )
}

  return (
    <React.Fragment>
      

        <ul className="topnav">
        
        <li><Link className="navmen" to="/home">Home</Link></li>
        {userrights.recordings === 1  &&
        <li><Link className="navmen" to="/recordings">{intl.get('RECORDINGS')}</Link></li>
        }     
        {userrights.auditLog === 1  &&
         <Fragment>
        <li><Link className="navmen" to="/activities">{intl.get('AUDITLOG')}</Link></li>
        </Fragment>
        }
        
        {userrights.systemLog === 1 &&
        <Fragment>
        <li><Link className="navmen" to="/logs">{intl.get('SYSTEMLOG')}</Link></li>
        </Fragment>
        }

        {userrights.userManagement === 1 &&
        <Fragment>
        <li><Link className="navmen" to="/user">{intl.get('USERMANAGEMENT')}</Link></li>
        </Fragment>
        }




        <li><Link className="navmen" to="/account">{intl.get('KONTO')}</Link></li>
        <li onClick={()=>this.logout()}><Logout  /></li>
        </ul>
  
     
    </React.Fragment>
  );
}}

const mapStateToProps = state => ({
  state: state,
  apitoken: state.gettocken.apitoken,
  userrole: state.getuserdata.userme.roles,
  userrights: state.getuserdata.userrights
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    getTokenLogout: getTokenLogout,
    userLogout: userLogout,
    roleLogout: roleLogout
    }, dispatch);
}



export default connect(mapStateToProps,mapDispatchToProps)(AccountMenu);

